module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "collection",
    on: {
      "click": _vm.clickMethod
    }
  }, [_c('i', {
    staticClass: "icon-yishoucang",
    class: _vm.show ? 'yesCollection' : 'noCollection'
  }), _vm._v(" "), _c('span', [_vm._v("收藏")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-270b8e98"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/collection/collection.vue
// module id = 809
// module chunks = 39